import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { servicesAPI } from '../services/api';

// [NEW] Página pública de /m/:code (ver rota em App.js) — o destino do link curto e
// "amigável" de foto/vídeo de comprovação de serviço que aparece no relatório de
// venda (ver ReportsPage.jsx). Pensada pra caber num relatório IMPRESSO em papel:
// usenico.com.br/m/482f é curto o bastante pra digitar à mão, e essa página resolve
// o código pra mídia real. Sem Guard/Layout de propósito — quem abre pode nem ter
// conta no NICO (ex: alguém avaliando o carro antes de comprar).
export default function MediaLinkPage() {
  const { code } = useParams();
  const [state, setState] = useState({ loading: true, error: null, url: null, type: null });

  useEffect(() => {
    let cancelled = false;
    servicesAPI.resolveMediaLink(code)
      .then(d => { if (!cancelled) setState({ loading: false, error: null, url: d.url, type: d.media_type }); })
      .catch(() => { if (!cancelled) setState({ loading: false, error: 'Link não encontrado. Confira se o endereço foi digitado certinho.', url: null, type: null }); });
    return () => { cancelled = true; };
  }, [code]);

  return (
    <div style={{
      minHeight: '100vh', background: '#f4ede0', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', padding: '24px', boxSizing: 'border-box',
      fontFamily: "'DM Sans', sans-serif",
    }}>
      <img src="/nico-1.png" alt="NICO" style={{ height: '32px', marginBottom: '24px' }} />

      {state.loading && (
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div className="spinner" style={{ width: '22px', height: '22px' }} />
          <span style={{ color: '#6a7268', fontSize: '14px' }}>Carregando...</span>
        </div>
      )}

      {!state.loading && state.error && (
        <div style={{ textAlign: 'center', maxWidth: '340px' }}>
          <div style={{ fontSize: '40px', opacity: 0.3, marginBottom: '12px' }}>🔍</div>
          <p style={{ color: '#6a7268', fontSize: '14px', lineHeight: 1.6 }}>{state.error}</p>
        </div>
      )}

      {!state.loading && !state.error && (
        <div style={{ background: '#fff', borderRadius: '22px', padding: '16px', maxWidth: '520px', width: '100%', boxShadow: '0 20px 48px rgba(15,64,35,.14)', boxSizing: 'border-box' }}>
          {state.type === 'foto' ? (
            <img src={state.url} alt="Foto de comprovação do serviço" style={{ width: '100%', borderRadius: '14px', display: 'block' }} />
          ) : (
            <video src={state.url} controls autoPlay style={{ width: '100%', borderRadius: '14px', display: 'block' }} />
          )}
          <p style={{ textAlign: 'center', color: '#6a7268', fontSize: '12px', marginTop: '14px', marginBottom: 0 }}>
            Mídia de comprovação de serviço · verificada pelo NICO
          </p>
        </div>
      )}
    </div>
  );
}
